import RequestQuoteModal from 'modals/scripts/request_quote_modal'
import Track from 'tracking_events/scripts/track'

const BUTTON_SELECTOR = '.js-request-quote-btn'

class RequestQuoteButton {
  static async init () {
    $(document).on('click', BUTTON_SELECTOR, (e) => {
      const listingId = $(e.currentTarget).data('listing-id')
      this.open(listingId)
    })
  }

  static open (listingId) {
    RequestQuoteModal.init(listingId)

    new Track().send('event', {
      event_category: 'request_quote_button_click',
      listing_ids: [listingId]
    })
  }
}

export default RequestQuoteButton
